import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";  // ← Removed BrowserRouter import
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { AuthProvider } from "@/context/AuthContext";
import { AddressProvider } from "@/context/AddressContext";
import { ReviewProvider } from "@/context/ReviewContext";
import { SignInModal } from "@/components/auth/SignInModal";
import Index from "./pages/Index";
import CategoryPage from "./pages/CategoryPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import ReviewsPage from "./pages/ReviewsPage";
import CartPage from "./pages/CartPage";
import WishlistPage from "./pages/WishlistPage";
import OrdersPage from "./pages/OrdersPage";
import ProfilePage from "./pages/ProfilePage";
import SearchPage from "./pages/SearchPage";
import AllProductsPage from "./pages/AllProductsPage";
import BecomeSellerPage from "./pages/BecomeSellerPage";
import TrendingProductsPage from "./pages/TrendingProductsPage";
import NewArrivalsPage from "./pages/NewArrivalsPage";
import TestProductPage from "./pages/TestProductPage";
import PhoneAuthPage from "./pages/PhoneAuthPage";
import ReviewOrderPage from "./pages/ReviewOrderPage";
import PaymentPage from "./pages/PaymentPage";
import OrderConfirmationPage from "./pages/OrderConfirmationPage";
import AddressManagementPage from "./pages/AddressManagementPage";
import AddEditAddressPage from "./pages/AddEditAddressPage";
import LogoutPage from "./pages/LogoutPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import SellerProductsPage from "./pages/SellerProductsPage";
import NotFound from "./pages/NotFound";


const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <ReviewProvider>
          <CartProvider>
            <WishlistProvider>
              <AddressProvider>
                <Toaster />
                <Sonner />
                <SignInModal />
                {/* BrowserRouter is now in main.tsx – removed from here */}
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/products" element={<AllProductsPage />} />
                  <Route path="/category/:category" element={<CategoryPage />} />
                  <Route path="/product/:id" element={<ProductDetailPage />} />
                  <Route path="/p/:id" element={<ProductDetailPage />} />
                  <Route path="/seller/:sellerId" element={<SellerProductsPage />} />
                  <Route path="/product/:productId/reviews/:productName?" element={<ReviewsPage />} />
                  <Route path="/test-product" element={<TestProductPage />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/wishlist" element={<WishlistPage />} />
                  <Route path="/orders" element={<OrdersPage />} />
                  <Route path="/addresses" element={<AddressManagementPage />} />
                  <Route path="/address/add" element={<AddEditAddressPage />} />
                  <Route path="/address/edit" element={<AddEditAddressPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/search" element={<SearchPage />} />
                  <Route path="/trending" element={<TrendingProductsPage />} />
                  <Route path="/new-arrivals" element={<NewArrivalsPage />} />
                  <Route path="/become-seller" element={<BecomeSellerPage />} />
                  <Route path="/phone-auth" element={<PhoneAuthPage />} />
                  <Route path="/review-order" element={<ReviewOrderPage />} />
                  <Route path="/payment" element={<PaymentPage />} />
                  <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                  <Route path="/terms" element={<TermsOfServicePage />} />
                  <Route path="/refund-policy" element={<RefundPolicyPage />} />
                  <Route path="/logout" element={<LogoutPage />} />
                  <Route path="/404" element={<NotFound />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </AddressProvider>
            </WishlistProvider>
          </CartProvider>
        </ReviewProvider>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;